// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/scientia-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');
}
.Hero {
  width: 100vw;
  height: 160px;
  overflow: hidden;
  display: flex;
  position: relative;
  justify-content: space-between;
  background: linear-gradient(90deg, #6cffc8 4.08%, #66d1ff 95.54%);
}
@media screen and (max-width: 400px) {
  .Hero {
    height: 300px;
  }
}
.Hero .text {
  flex-direction: column;
  padding-left: 60px;
  padding-top: 40px;
  padding-bottom: 10px;
  padding-right: 10px;
}
.Hero .image {
  width: 600px;
  height: 200px;
  overflow: hidden;
  margin-right: 0;
}
.Hero .image .scientia-image {
  width: 700px;
  height: auto;
  flex-shrink: 0;
  opacity: 0.5;
  margin-right: 0px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), lightgray 50% / cover no-repeat;
}
@media screen and (max-width: 1215px) {
  .Hero .image {
    display: none;
  }
}
.h1-hero {
  color: #272931;
  font-family: 'Open Sans', sans-serif;
  font-size: 19px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media screen and (max-width: 1400px) {
  .h1-hero {
    font-size: 14px;
  }
}
@media screen and (max-width: 1215px) {
  .h1-hero {
    font-size: 16px;
  }
}
.h3-hero {
  color: #272931;
  /* H3 */
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 5px 0px;
}
@media screen and (max-width: 1400px) {
  .h3-hero {
    font-size: 20px;
  }
}
@media screen and (max-width: 1300px) {
  .h3-hero {
    font-size: 18px;
  }
}
@media screen and (max-width: 1215px) {
  .h3-hero {
    font-size: 24px;
  }
}
.scientia-hero {
  color: #272931;
  font-family: 'Open Sans', sans-serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -1.28px;
}
@media screen and (max-width: 1300px) {
  .scientia-hero {
    font-size: 28px;
  }
}
@media screen and (max-width: 1215px) {
  .scientia-hero {
    font-size: 36px;
  }
}
.learn-about-button {
  display: inline-flex;
  padding: 9px 12px 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #c3ffe2;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1), 0px 3px 14px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.07);
  border: none;
  color: #272931;
  /* Button Text */
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}
.hero-loggedout-spacer {
  height: 0;
}
`, "",{"version":3,"sources":["https:/fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap","webpack://./src/components/Hero.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;AA5BA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EAEA,iEAAA;AA6BJ;AA5BI;EAAA;IACE,aAAA;EA+BJ;AACF;AA1CA;EAaM,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAgCN;AAjDA;EAoBM,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAgCN;AAvDA;EAyBQ,YAAA;EACA,YAAA;EAEA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,oFAAA;AAgCR;AA7BM;EAAA;IACE,aAAA;EAgCN;AACF;AA5BE;EACE,cAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA8BJ;AA7BI;EAAA;IACE,eAAA;EAgCJ;AACF;AA9BC;EAAA;IACC,eAAA;EAiCA;AACF;AA7BE;EACE,cAAA;EA+BF,OAAO;EA7BL,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA+BJ;AA9BI;EAAA;IACE,eAAA;EAiCJ;AACF;AAhCG;EAAA;IACC,eAAA;EAmCF;AACF;AAlCC;EAAA;IACC,eAAA;EAqCA;AACF;AAlCE;EACE,cAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAoCJ;AAlCG;EAAA;IACC,eAAA;EAqCF;AACF;AApCC;EAAA;IACC,eAAA;EAuCA;AACF;AAnCE;EACE,oBAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EAEA,0HAAA;EAGA,YAAA;EACA,cAAA;EAkCF,gBAAgB;EA/Bd,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAiCJ;AA9BE;EACE,SAAA;AAgCJ","sourcesContent":["@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');\n}\n","@import \"../styles/scientia-colors.less\";\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');\n\n.Hero {\n    width: 100vw;\n    height: 160px;\n    overflow: hidden;\n    display: flex;\n    position: relative;\n    justify-content: space-between;\n    // padding-top: 70px;\n    background: linear-gradient(90deg, @scientia-green 4.08%, @scientia-blue 95.54%);\n    @media screen and (max-width: 400px) {\n      height: 300px;\n   }\n    .text {\n      flex-direction: column;\n      padding-left: 60px;\n      padding-top: 40px;\n      padding-bottom: 10px;\n      padding-right: 10px;\n    }\n    .image {\n      width: 600px;\n      height: 200px;\n      overflow: hidden;\n      margin-right: 0;\n      .scientia-image {\n        width: 700px;\n        height: auto;\n\n        flex-shrink: 0;\n        opacity: 0.5;\n        margin-right: 0px;\n        background: url(../images/scientia-image.png),\n          lightgray 50% / cover no-repeat;\n      }\n      @media screen and (max-width: 1215px) {\n        display: none;\n     }\n    }\n  }\n  \n  .h1-hero {\n    color: @scientia-dark;\n    font-family: 'Open Sans', sans-serif;\n    font-size: 19px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    @media screen and (max-width: 1400px) {\n      font-size: 14px;\n   }\n\n @media screen and (max-width: 1215px) {\n  font-size: 16px;\n}\n\n  }\n\n  .h3-hero {\n    color: @scientia-dark;\n    /* H3 */\n    font-family: 'Open Sans', sans-serif;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    padding: 5px 0px;\n    @media screen and (max-width: 1400px) {\n      font-size: 20px;\n   }\n   @media screen and (max-width: 1300px) {\n    font-size: 18px;\n }\n @media screen and (max-width: 1215px) {\n  font-size: 24px;\n}\n\n  }\n  .scientia-hero {\n    color: @scientia-dark;\n    font-family: 'Open Sans', sans-serif;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: -1.28px;\n\n   @media screen and (max-width: 1300px) {\n    font-size: 28px;\n }\n @media screen and (max-width: 1215px) {\n  font-size: 36px;\n}\n\n  }\n\n  .learn-about-button {\n    display: inline-flex;\n    padding: 9px 12px 9px 16px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 4px;\n    background: @scientia-light-green;\n  \n    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1),\n      0px 3px 14px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.07);\n  \n    border: none;\n    color: @scientia-dark;\n  \n    /* Button Text */\n    font-family: Open Sans;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.8px;\n    text-transform: uppercase;\n  }\n  \n  .hero-loggedout-spacer {\n    height: 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
